/* eslint-disable max-len */
var ICON_UI_CIRCLE_MINUS = {
  v2: true,
  "default": 'M6.3778 11.9512H17.4267M12 23C18.0751 23 23 18.0752 23 12.0001C23 5.92493 18.0751 1 12 1C5.9249 1 1.00003 5.92493 1.00003 12.0001C1.00003 18.0752 5.9249 23 12 23Z',
  globetrotter: 'M7.5 12H16.5M22.125 12C22.125 17.595 17.595 22.125 12 22.125C6.405 22.125 1.875 17.595 1.875 12C1.875 6.405 6.405 1.875 12 1.875C17.595 1.875 22.125 6.405 22.125 12Z'
};

export { ICON_UI_CIRCLE_MINUS };
//# sourceMappingURL=ICON_UI_CIRCLE_MINUS.js.map
